import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import ChatConversation from "@/components/ChatConversation";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div
          className="fixed bottom-44 right-4 sm:right-6 z-40 w-[92vw] max-w-sm h-[70vh] bg-surface-container-lowest rounded-3xl shadow-ambient-lg p-4 flex flex-col animate-rise-in"
          data-testid="chat-widget-panel"
        >
          <div className="flex items-center justify-between mb-2 shrink-0">
            <div>
              <p className="font-headline text-primary text-lg">Vitalize Assistant</p>
              <p className="text-xs text-on-surface-variant">Instant answers, anytime</p>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="w-9 h-9 rounded-full hover:bg-surface-container flex items-center justify-center text-on-surface-variant transition-colors duration-300"
              data-testid="chat-widget-close"
            >
              <X className="w-5 h-5" strokeWidth={1.5} />
            </button>
          </div>
          <div className="flex-1 min-h-0">
            <ChatConversation compact />
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-28 right-4 sm:right-6 w-14 h-14 rounded-2xl zenith-cta text-white shadow-ambient-lg flex items-center justify-center z-40 transition-transform duration-300 hover:scale-105"
        data-testid="chat-widget-button"
      >
        {open ? <X className="w-6 h-6" strokeWidth={1.5} /> : <MessageCircle className="w-6 h-6" strokeWidth={1.5} />}
        {!open && <span className="absolute top-1.5 right-1.5 w-3 h-3 rounded-full bg-secondary-container" />}
      </button>
    </>
  );
}
